// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {
    getImplementsDetails
} from '../../shared/repositories';

export const updateImplements = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getImplementsDetails(pin);

            const purchaseOrder = payload && payload.purchaseOrder;

            dispatch({
                payload,
                property: 'baseMachineComponents',
                type: actions.UPDATE_PRODUCT_IMPLEMENTS_SUCCESS
            });

            dispatch({
                purchaseOrder,
                type: actions.UPDATE_TEMP_PRODUCT_IMPLEMENTS_PURCHASE_ORDER
            });

            dispatch({

                type: actions.CREATE_PRODUCT_DETAILS_COMPONENTS

            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };




// WEBPACK FOOTER //
// ./src/product/details/action-creators/implements.js